// personel-takip/src/pages/AdminPage.js
import React, { useEffect, useMemo, useState, useRef } from "react";
import { useAuth } from "../../../context/AuthContext";
import { db } from "../firebaseConfig";
import {
  collection, addDoc, updateDoc, getDocs, deleteDoc, doc,
  Timestamp, query, where, limit, setDoc
} from "firebase/firestore";
import { getAuth } from "firebase/auth";
import * as XLSX from "xlsx";
import Select from "react-select";

/* ----------------- küçük yardımcılar ----------------- */
const pad2 = (n) => String(n).padStart(2, "0");
const toISO = (y, m, d) => `${y}-${pad2(m)}-${pad2(d)}`;
const ymStr = (y, m) => `${y}${pad2(m)}`;
// (EK) puantaj panelinden gelen yardımcılar:
const ymmm = (y, m) => `${y}${pad2(m)}`;
const daysInMonth = (y, m) => new Date(y, m, 0).getDate();
const incYM = (y, m) => { m += 1; if (m > 12) { y++; m = 1; } return [y, m]; };
const isSunday = (y, m, d) => new Date(y, m - 1, d).getDay() === 0;
const weekday = (y, m, d) => new Date(y, m - 1, d).getDay(); // 0..6
const norm = (s = "") => String(s).toUpperCase().replaceAll("İ","I").replaceAll("ı","I").trim();

const parseDate = (s) => {
  if (!s) return null;
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) { const [Y,M,D] = s.split("-").map(Number); return new Date(Y, M-1, D); }
  const d = new Date(s); return Number.isFinite(+d) ? d : null;
};
const addDays = (d, n) => { const x = new Date(d); x.setDate(x.getDate()+n); return x; };
const getYMD = (d) => [d.getFullYear(), d.getMonth()+1, d.getDate()];

/* ---- aktiflik (giris/cikis) ---- */
const parseDotOrISO = (v) => {
  if (!v) return null;
  if (v?.toDate) return v.toDate();
  const s = String(v);
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return new Date(s);
  const s2 = s.replaceAll("/", ".").replaceAll("-", ".");
  const m = s2.match(/^(\d{1,2})\.(\d{1,2})\.(\d{4})$/);
  if (!m) return null;
  return new Date(+m[3], +m[2]-1, +m[1]);
};
const getIntervals = (tarih = {}) => {
  const g = [], c = [];
  for (const [k,v] of Object.entries(tarih||{})) {
    if (!v) continue;
    if (k.startsWith("giris")) g.push([k, parseDotOrISO(v)]);
    if (k.startsWith("cikis")) c.push([k, parseDotOrISO(v)]);
  }
  const num = (s) => +(s.match(/\d+/)?.[0] || 0);
  g.sort((a,b)=>num(a[0])-num(b[0])); c.sort((a,b)=>num(a[0])-num(b[0]));
  const out=[]; for(let i=0;i<g.length;i++){ const start=g[i][1]; const end=c[i]?.[1]||null; if(start) out.push([start,end]); }
  return out;
};
const isActiveOn = (tarih, y, m, d) => {
  const ivs = getIntervals(tarih||{});
  const dt = new Date(y, m-1, d);
  return ivs.some(([s,e]) => { const end = e ? new Date(e.getFullYear(), e.getMonth(), e.getDate()+1) : null; return s<=dt && (!end || end>dt); });
};
const isActiveInMonth = (tarih = {}, y, m) => {
  const start = new Date(y, m - 1, 1);
  const end = new Date(y, m, 1);
  const ivs = getIntervals(tarih);
  return ivs.some(([s, e]) => {
    const ivEnd = e ? new Date(e.getFullYear(), e.getMonth(), e.getDate() + 1) : null;
    return (s < end) && (!ivEnd || ivEnd > start);
  });
};

/* -------------------- Korumalı statüler -------------------- */
const STATUS_PROTECTED = new Set(["IZIN","YILLIK","UCRETSIZ","RAPOR","RESMI_TATIL"]);

/* ======================================================
   BİLEŞEN
====================================================== */
const AdminPage = () => {
  const { user, role } = useAuth();

  /* --- (mevcut admin alanları) --- */
  const [email,setEmail]=useState(""); const [password,setPassword]=useState("123456");
  const [roleNew,setRoleNew]=useState("Kullanıcı"); const [message,setMessage]=useState("");
  const [deactivateEmail,setDeactivateEmail]=useState("");

  const [plate,setPlate]=useState(""); const [type,setType]=useState("");
  const [model,setModel]=useState(""); const [facility,setFacility]=useState("");
  const [aciklama,setAciklama]=useState(""); const [existingPlates,setExistingPlates]=useState([]);
  const [isNewPlate,setIsNewPlate]=useState(true); const [authEmail,setAuthEmail]=useState("");

  const [searchDate,setSearchDate]=useState(""); const [newDate,setNewDate]=useState("");
  const [issues,setIssues]=useState([]); const [selectedIds,setSelectedIds]=useState([]);

  /* ---------- personeller / puantaj / facet durumları ---------- */
  const [persons,setPersons]=useState([]);                 // personeller koleksiyonu
  const [allStatuses,setAllStatuses]=useState({});         // pid -> iso -> status
  const [facets,setFacets]=useState({ tesis:[], gorev:[] });

  // 📧 Personel Erişimi paneli
  const [selPersonOpt, setSelPersonOpt] = useState(null);
  const [selPersonTesis, setSelPersonTesis] = useState("");
  const [selPersonEmail, setSelPersonEmail] = useState("");
  const [selPersonGorTes, setSelPersonGorTes] = useState([]); // Select options
  const [savingAccess, setSavingAccess] = useState(false);

  /* ---------- auth email ---------- */
  useEffect(()=>{ const auth=getAuth(); const unsub=auth.onAuthStateChanged(u=>{ if(u) setAuthEmail(u.email||""); }); return ()=>unsub(); },[]);

  /* ---------- plakalar ---------- */
  useEffect(()=>{ (async()=>{
    const snapshot=await getDocs(collection(db,"plates"));
    const data=snapshot.docs.map(d=>({id:d.id, ...d.data()}));
    const sorted=data.sort((a,b)=>(a.plate||"").localeCompare(b.plate||"","tr"));
    setExistingPlates(sorted);
  })();},[]);

  /* ---------- personeller & puantaj ---------- */
  const refreshPersons = async () => {
    const ps=await getDocs(collection(db,"personeller"));
    const arrRaw=ps.docs.map(d=>({id:d.id, ...(d.data()||{})}));
    const arr=arrRaw;
    setPersons(arr);

    const tset=new Set(), gset=new Set();
    arr.forEach(p=>{ if (p.tesis) tset.add(String(p.tesis).trim()); if (p.gorev) gset.add(String(p.gorev).trim()); });
    setFacets({ tesis:[...tset].sort((a,b)=>a.localeCompare(b,"tr")), gorev:[...gset].sort((a,b)=>a.localeCompare(b,"tr")) });
  };

  useEffect(()=>{ (async()=>{
    try{
      await refreshPersons();

      const pv2=await getDocs(collection(db,"puantajV2"));
      const byPid={};
      pv2.docs.forEach(d=>{
        const v=d.data()||{}; const pid=v.personelId; const iso=v.date;
        if(!pid||!iso) return; if(!byPid[pid]) byPid[pid]={}; byPid[pid][iso]=v.status;
      });
      setAllStatuses(byPid);
    }catch(e){ console.error("[AdminPage] read error:", e); }
  })();},[]);

  /* ------------------- mevcut admin fonksiyonları (kısaltıldı) ------------------- */
  const handleCreate=async()=>setMessage("⚠️ createNewUser bu projede yok (iskelet).");
  const handleDeactivate=async()=>setMessage("⚠️ deactivateUser bu projede yok (iskelet).");
  const handleAddOrUpdatePlate=async()=>{/* mevcut kodun */};
  const handleTamamlaEksikAlanlar=async()=>{/* mevcut kodun */};
  const handlePlateSelect=(e)=>{/* mevcut kodun */};
  const handleDeleteAllLogins=async()=>{/* mevcut kodun */};
  const handleFindIssuesByDate=async()=>{/* mevcut kodun */};
  const handleUpdateSelectedDates=async()=>{/* mevcut kodun */};

  /* ==================== İZİN YAZMA ==================== */
  const writeLeave = async (pid, y, m, d, note="") => {
    const iso = toISO(y,m,d);
    const key = `${pid}_${ymStr(y,m)}${pad2(d)}`;
    await setDoc(doc(db,"puantajV2",key), {
      personelId: pid, date: iso, yyyymm: ymStr(y,m), status: "IZIN",
      note, enteredBy: { email: authEmail || "-" }, enteredAt: Timestamp.now(),
    }, { merge:true });
    setAllStatuses(prev=>{ const n={...prev}; if(!n[pid]) n[pid]={}; n[pid][iso]="IZIN"; return n; });
  };

  /* ==================== (EK) TOPLU AYLIK İZİN DOLDUR YARDIMCILARI ==================== */

  const activeSundays = (p, y, m) => {
    const dom = daysInMonth(y, m);
    const list = [];
    for (let d = 1; d <= dom; d++) {
      if (!isSunday(y, m, d)) continue;
      if (isActiveOn(p.tarih || {}, y, m, d)) list.push(d);
    }
    return list;
  };

  const usedPaidInMonthFromSnapshot = (rows, pid, y, m) => {
    const ym = ymmm(y, m);
    let used = 0;
    for (const r of rows) {
      const v = r.data() || {};
      if (v.personelId !== pid || v.yyyymm !== ym) continue;
      const dt = v.date ? new Date(v.date) : null;
      const isSun = dt ? dt.getDay() === 0 : false;
      if (v.status === "IZIN") used++;
      else if (v.status === "RAPOR" && isSun) used++;
    }
    return used;
  };

  const fillMonthForAll = async (y, m) => {
    // Aktif personeller (ay içinde)
    const snapP = await getDocs(collection(db, "personeller"));
    let plist = snapP.docs.map(d => ({ id: d.id, ...d.data() }))
      .filter(p => isActiveInMonth(p.tarih || {}, y, m));

    const ym = ymmm(y, m);
    const snapM = await getDocs(query(collection(db, "puantajV2"), where("yyyymm", "==", ym)));

    for (const p of plist) {
      // Hedef: ayın pazar sayısı kadar ücretli izin hakkı
      const sundays = activeSundays(p, y, m);
      const hak = sundays.length;
      if (hak <= 0) continue;

      const alreadyUsed = usedPaidInMonthFromSnapshot(snapM.docs, p.id, y, m);
      const remaining = Math.max(0, hak - alreadyUsed);
      if (remaining === 0) continue;

      // O ayda zaten bir statü yazılmış günleri çıkar
      const takenSet = new Set();
      snapM.docs.forEach(d => {
        const v = d.data() || {};
        if (v.personelId !== p.id || v.yyyymm !== ym) return;
        const dd = parseInt(String(v.date || "").slice(-2), 10);
        if (!dd) return;
        if (["IZIN","YILLIK","UCRETSIZ","RAPOR","RESMI_TATIL"].includes(v.status)) takenSet.add(dd);
      });

      const candidates = sundays.filter(d => !takenSet.has(d));
      for (let i = 0; i < Math.min(remaining, candidates.length); i++) {
        const d = candidates[i];
        await writeLeave(p.id, y, m, d, "Toplu atama (pazar)");
      }
    }
  };

  const [bulkStartYM, setBulkStartYM] = useState(""); // YYYY-MM
  const [bulkEndYM, setBulkEndYM] = useState("");

  const runBulk = async () => {
    if (!bulkStartYM || !bulkEndYM) return alert("Başlangıç ve bitiş ayını seçin.");
    let [sy, sm] = bulkStartYM.split("-").map(Number);
    let [ey, em] = bulkEndYM.split("-").map(Number);
    if (!sy || !sm || !ey || !em) return alert("Ay formatı geçersiz.");

    while (sy < ey || (sy === ey && sm <= em)) {
      await fillMonthForAll(sy, sm);
      [sy, sm] = incYM(sy, sm);
    }
    alert("Toplu atama başarıyla tamamlandı.");
  };

  /* ================== SAYFA ================== */
  return (
    <div style={{ padding:20, maxWidth:1000, margin:"auto", fontFamily:'system-ui,-apple-system,"Segoe UI",Roboto,Arial' }}>
      <style>{`
        .panel{border:1px solid #e5e7eb;border-radius:10px;padding:14px;margin:18px 0;background:#fff}
        .h{font-weight:700;margin:0 0 10px 0}
        .row{display:flex; gap:10px; flex-wrap:wrap; align-items:center}
        .btn{padding:10px 16px; background:#1e40af; color:#fff; border:none; border-radius:6px; cursor:pointer}
        .btn.gray{background:#6b7280}
        .btn.red{background:#dc2626}
        .inp{padding:8px 10px; border:1px solid #d1d5db; border-radius:6px}
        .log{background:#0f172a; color:#e5e7eb; font-family:ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono"; padding:10px; border-radius:8px; max-height:240px; overflow:auto}
        .section-title{font-weight:700;margin:30px 0 12px}
        .table{width:100%; border-collapse:collapse}
        .table th,.table td{border:1px solid #e5e7eb; padding:8px; text-align:left; vertical-align:top}
        .muted{color:#64748b}
      `}</style>

      {/* ==== (MEVCUT TASARIM) Yeni Kullanıcı Oluştur ==== */}
      <h3 className="section-title">Yeni Kullanıcı Oluştur (İskelet)</h3>
      <input placeholder="E-posta" value={email} onChange={(e)=>setEmail(e.target.value)} className="inp" />
      <input type="password" placeholder="Şifre" value={password} onChange={(e)=>setPassword(e.target.value)} className="inp" />
      <select value={roleNew} onChange={(e)=>setRoleNew(e.target.value)} className="inp">
        <option value="Yetkili">Yetkili</option>
        <option value="Kullanıcı">Kullanıcı</option>
        <option value="Oluşturucu">Oluşturucu</option>
      </select>
      <button onClick={handleCreate} className="btn">Kullanıcı Oluştur</button>

      {/* ==== (MEVCUT TASARIM) Kullanıcıyı Pasif Yap ==== */}
      <h3 className="section-title">Kullanıcıyı Pasif Yap (İskelet)</h3>
      <input placeholder="E-posta girin" value={deactivateEmail} onChange={(e)=>setDeactivateEmail(e.target.value)} className="inp" />
      <button onClick={handleDeactivate} className="btn">Pasifleştir</button>

      {/* ==== (MEVCUT TASARIM) Plaka Ekle / Güncelle ==== */}
      <h3 className="section-title">Plaka Ekle / Güncelle</h3>
      <select onChange={(e)=>handlePlateSelect(e)} value={isNewPlate ? "__new__" : plate} className="inp">
        <option value="__new__">Yeni Plaka Ekle</option>
        {existingPlates.map((p)=>(
          <option key={p.id} value={p.plate}>{p.plate}</option>
        ))}
      </select>
      {isNewPlate && (
        <input placeholder="Yeni Plaka Girin" value={plate} onChange={(e)=>setPlate(e.target.value.toUpperCase().replace(/\s+/g,""))} className="inp" />
      )}
      <input placeholder="Araç Cinsi" value={type} onChange={(e)=>setType(e.target.value)} className="inp" />
      <input placeholder="Model" value={model} onChange={(e)=>setModel(e.target.value)} className="inp" />
      <input placeholder="Tesis" value={facility} onChange={(e)=>setFacility(e.target.value)} className="inp" />
      <input placeholder="Açıklama" value={aciklama} onChange={(e)=>setAciklama(e.target.value)} className="inp" />
      <button onClick={handleAddOrUpdatePlate} className="btn">Kaydet</button>
      <button onClick={handleTamamlaEksikAlanlar} className="btn" style={{ backgroundColor:"#eab308", marginLeft:8 }}>🛠 Eksik Alanları Tamamla</button>

      {/* ==== (MEVCUT TASARIM) Tüm Giriş Kayıtlarını Sil ==== */}
      <h3 className="section-title">Tüm Giriş Kayıtlarını Sil</h3>
      <button onClick={handleDeleteAllLogins} className="btn red">Tüm Logları Temizle</button>

      {/* ==== (MEVCUT TASARIM) Eksiklik Tarihi Toplu Güncelle ==== */}
      <h3 className="section-title">Eksiklik Tarihi Toplu Güncelle</h3>
      <div className="row">
        <input type="date" value={searchDate} onChange={(e)=>setSearchDate(e.target.value)} className="inp" />
        <button onClick={handleFindIssuesByDate} className="btn">Eksiklikleri Listele</button>
      </div>
      {issues.length>0 && (
        <>
          <ul style={{ marginTop:8 }}>
            {issues.map((issue)=>(
              <li key={issue.id}>
                <input
                  type="checkbox"
                  checked={selectedIds.includes(issue.id)}
                  onChange={()=>{
                    setSelectedIds(prev=> prev.includes(issue.id) ? prev.filter(id=>id!==issue.id) : [...prev, issue.id]);
                  }}
                />
                &nbsp;<b>{issue.plate}</b> | {issue.issue} | {issue.date?.toDate().toLocaleDateString("tr-TR")}
              </li>
            ))}
          </ul>
          <div className="row">
            <input type="date" value={newDate} onChange={(e)=>setNewDate(e.target.value)} className="inp" />
            <button onClick={handleUpdateSelectedDates} className="btn" style={{ backgroundColor:"#059669" }}>Seçilenlerin Tarihini Güncelle</button>
          </div>
        </>
      )}

      {/* ================== 📧 PERSONEL ERİŞİMİ ================== */}
      <div className="panel">
        <h3 className="h">Personel Erişimi (Email & Görebileceği Tesisler)</h3>

        <div className="row" style={{ alignItems:"flex-end" }}>
          <div>
            <div style={{ fontWeight:600, marginBottom:6 }}>İsim (pasifler listelenmez)</div>
            <Select
              options={persons
                .filter(p => p.aktif !== false)
                .sort((a,b)=> (a.ad||"").localeCompare(b.ad||"","tr") || (a.soyad||"").localeCompare(b.soyad||"","tr"))
                .map(p => ({ value: p.id, label: `${p.ad||""} ${p.soyad||""}`.trim() }))
              }
              value={selPersonOpt}
              onChange={(opt)=>{
                setSelPersonOpt(opt);
                if (!opt) {
                  setSelPersonTesis(""); setSelPersonEmail(""); setSelPersonGorTes([]); return;
                }
                const p = persons.find(x => x.id === opt.value);
                const gt = Array.isArray(p?.gorebilecegiTesisler) ? p.gorebilecegiTesisler : [];
                setSelPersonTesis(p?.tesis || "");
                setSelPersonEmail(p?.email || "");
                setSelPersonGorTes(gt.map(t=>({value:t,label:t})));
              }}
              placeholder="Personel ara ve seç…"
              isSearchable
              menuPortalTarget={typeof document!=="undefined"?document.body:null}
              styles={{ menuPortal:(b)=>({...b,zIndex:9999}), control:(b)=>({...b,minWidth:280}) }}
            />
          </div>

          <div>
            <div style={{ fontWeight:600, marginBottom:6 }}>Tesis</div>
            <input className="inp" value={selPersonTesis} readOnly />
          </div>

          <div>
            <div style={{ fontWeight:600, marginBottom:6 }}>Görebileceği Tesisler</div>
            <Select
              isMulti
              options={[...new Set(persons.map(p=>p.tesis).filter(Boolean))].sort((a,b)=>a.localeCompare(b,"tr")).map(t=>({value:t,label:t}))}
              value={selPersonGorTes}
              onChange={(v)=>setSelPersonGorTes(v||[])}
              placeholder="Tesis seç…"
              isSearchable
              closeMenuOnSelect={false}
              menuPortalTarget={typeof document!=="undefined"?document.body:null}
              styles={{ menuPortal:(b)=>({...b,zIndex:9999}), control:(b)=>({...b,minWidth:280}) }}
            />
          </div>

          <div>
            <div style={{ fontWeight:600, marginBottom:6 }}>Email</div>
            <input
              className="inp"
              value={selPersonEmail}
              onChange={(e)=>setSelPersonEmail(e.target.value)}
              placeholder="ornek@firma.com"
              style={{ minWidth:260 }}
            />
          </div>

          <button
            className="btn"
            onClick={async ()=>{
              if (!selPersonOpt) return alert("Önce personel seçin.");
              setSavingAccess(true);
              try {
                const pid = selPersonOpt.value;
                const newEmail = String(selPersonEmail || "").trim();
                const newList = (selPersonGorTes || []).map(o => String(o.value));
                await updateDoc(doc(db, "personeller", pid), { email: newEmail, gorebilecegiTesisler: newList });
                setPersons(prev => prev.map(p => p.id !== pid ? p : ({ ...p, email: newEmail, gorebilecegiTesisler: newList })));
                alert("✅ Erişim bilgileri güncellendi.");
                setSelPersonOpt(null); setSelPersonTesis(""); setSelPersonEmail(""); setSelPersonGorTes([]);
              } catch (e) { console.error(e); alert("❌ Kaydetme sırasında hata oluştu."); }
              finally { setSavingAccess(false); }
            }}
            disabled={savingAccess}
          >
            {savingAccess ? "Kaydediliyor…" : "Kaydet"}
          </button>
        </div>

        <div style={{ marginTop:16 }}>
          <div style={{ fontWeight:700, marginBottom:8 }}>Email girilmiş personeller</div>
          {persons.filter(p => (p.email||"").trim()!=="").length === 0 ? (
            <div className="muted">Henüz email atanmış personel yok.</div>
          ) : (
            <table className="table">
              <thead>
                <tr>
                  <th>Ad Soyad</th>
                  <th>Tesis</th>
                  <th>Email</th>
                  <th>Görebileceği Tesisler</th>
                  <th>İşlem</th>
                </tr>
              </thead>
              <tbody>
                {persons
                  .filter(p => (p.email||"").trim()!=="")
                  .sort((a,b)=> (a.ad||"").localeCompare(b.ad||"","tr") || (a.soyad||"").localeCompare(b.soyad||"","tr"))
                  .map(p => (
                  <tr key={p.id}>
                    <td>{`${p.ad || ""} ${p.soyad || ""}`.trim()}</td>
                    <td>{p.tesis || "-"}</td>
                    <td>{p.email}</td>
                    <td>{Array.isArray(p.gorebilecegiTesisler) ? p.gorebilecegiTesisler.join(", ") : "-"}</td>
                    <td style={{ whiteSpace:"nowrap" }}>
                      <button
                        className="btn gray"
                        onClick={()=> {
                          const opt = { value: p.id, label: `${p.ad||""} ${p.soyad||""}`.trim() };
                          setSelPersonOpt(opt);
                          setSelPersonTesis(p.tesis || "");
                          setSelPersonEmail(p.email || "");
                          setSelPersonGorTes((p.gorebilecegiTesisler||[]).map(t=>({value:t,label:t})));
                        }}
                      >
                        Düzenle
                      </button>
                      &nbsp;
                      <button className="btn red" onClick={async ()=>{
                        try {
                          await updateDoc(doc(db, "personeller", p.id), { email: "" });
                          setPersons(prev => prev.map(x => x.id !== p.id ? x : ({ ...x, email: "" })));
                        } catch (e) { console.error(e); alert("❌ Email silinemedi."); }
                      }}>Emaili Sil</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>

      {/* ================== 🗓️ TOPLU AYLIK İZİN DOLDUR (YENİ PANEL) ================== */}
      <div className="panel" style={{ marginBottom: 10 }}>
        <h3 className="h">Toplu Aylık İzin Doldur</h3>
        <div className="row" style={{ marginBottom: 6 }}>
          <label>Başlangıç:
            <input type="month" className="inp" value={bulkStartYM} onChange={(e)=>setBulkStartYM(e.target.value)} style={{marginLeft:6}}/>
          </label>
          <label>Bitiş:
            <input type="month" className="inp" value={bulkEndYM} onChange={(e)=>setBulkEndYM(e.target.value)} style={{marginLeft:6}}/>
          </label>
          <button className="btn" onClick={runBulk} title="Seçili aralıktaki ayları otomatik doldur">Seçili ayları otomatik doldur</button>
        </div>
        <div className="muted" style={{fontSize:12}}>
          Kural: Ayın <b>pazar</b> sayısı kadar hak. Pazar gününe denk gelen <b>RAPOR</b> ücretli izne sayılır.
          Mevcutta yazılmış (İ/Y/Ü/R/T) günlere dokunulmaz, kalan pazarlar “İzin” yazılır.
        </div>
      </div>

      {message && <p style={{ marginTop:20, color: message.includes("✅") ? "green" : "red" }}>{message}</p>}
    </div>
  );
};

export default AdminPage;
